module.exports = __webpack_public_path__ + "static/media/ди.5b26cf2f.mp3";